<template>
  <div class="pa-10">
    <SkillsAssessmentDataTable />
  </div>
</template>

<script>
import SkillsAssessmentDataTable from "@/components/Utils/SkillsAssessmentDataTable.vue";

export default {
  components: {
    SkillsAssessmentDataTable,
  },
  created() {
    if (this.$store.state.expiryDate < Date.now()) {
      this.$store.dispatch("setUser", null);
      this.$store.dispatch("setIsAuthenticated", 0);
      this.render = true;
      this.$router.push("/");
    }
  },
  data: () => ({
    typeData: [],
    action: null,
    reload: false,
  }),
  methods: {
    // shouldShow() {
    //   let allowed = [2, 3];
    //   return allowed.includes($store.state.user.usertype.id);
    // },
  },
};
</script>

<style></style>
